<app-user-roles-grid
  [entityChanged$]="entityId$"
  (hasRolesUpdated)="hasRolesUpdated($event)"></app-user-roles-grid>
<app-user-permissions-grid
  [entityChanged$]="entityId$"
  [shouldRefresh$]="hasUpdates$"></app-user-permissions-grid>
